<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 py-1 mb-2 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t($route.name, { name: $store.state.studentLabel }) }} {{ (event ? event.name : '') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
      <log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="filter = true"
            >
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }}</span>
      </v-tooltip>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        ref="refExcel"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              v-on="on"
            >
              <v-icon
                style="font-size: 22px"
                color="green"
              >
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('excel') }}</span>
        </v-tooltip>
      </export-excel>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0">
      <v-col
        v-if="!eventProp"
        cols="12"
        md="3"
      >
        <autocomplete
          v-model="event"
          title="academyEventName"
          type="academyEvent"
          :value="event"
        />
      </v-col>
      <v-col
        class="pb-2 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          flat
          solo
          height="30"
          background-color="#e5e5e5"
          dense
          clearable
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2 mt-2"
    >
      <v-data-table
        v-if="headers"
        :height="tableHeight"
        fixed-header
        ref="datatable"
        v-model="selected"
        :page.sync="page"
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :show-select="showSelect"
        multi-sort
        item-key="id"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-clipboard-edit
                  </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('customerEdit', item)"
                      >
                        <v-icon
                          small
                          color="primary"
                        >
                          mdi-content-duplicate
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('newTab') }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="events(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyEventList')" />
              </v-list-item>
              <v-list-item
                link
                @click="turnover(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('turnover')" />
              </v-list-item>
              <v-list-item
                link
                @click="payment(item, 'pay')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('payCash')" />
              </v-list-item>
              <v-list-item
                link
                @click="payment(item, 'recieve')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('cashReceive')" />
              </v-list-item>
              <v-list-item
                link
                @click="studentAttendance(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyEventStudentAttandance', {name: $store.state.studentLabel})" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1 mb-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.firstname="{ item }">
          <a @click="edit(item)">
            {{ item.firstname }} {{ (item.lastname ? item.lastname : '') }} {{ (item.code ? '(' + item.code + ')' : '') }}
          </a>
        </template>
        <template v-slot:item.attraction_method_id="{ item }">
          {{ (item.attraction_method ? item.attraction_method.name : '') }}
        </template>
        <template v-slot:item.task-relation="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                x-small
                class="mx-1"
                v-on="on"
                @click="openTaskDialog(item)"
              >
                {{ $t('new-task') }}
                <v-icon
                  small
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-task') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="error"
                overlap
                :content="item.taskCount"
                :value="item.taskCount"
              >
                <v-btn
                  v-if="item.taskCount > 0"
                  v-bind="attrs"
                  color="cyan"
                  x-small
                  v-on="on"
                  @click="openTaskDialogList(item)"
                >
                  {{ $t('tasks') }}
                  <v-icon small>
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ $t('tasks') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.phone="{ item }">
          <a
            v-if="item.phone"
            :href="'tel:' + item.phone"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ item.phone }}
              <v-icon
                dark
                small
                style="font-size: 12px"
              >
                mdi-phone
              </v-icon>
            </v-btn>
          </a>
        </template>
        <template v-slot:item.mobile="{ item }">
          <a
            v-if="item.mobile"
            :href="'tel:' + item.mobile"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ item.mobile }}
              <v-icon
                dark
                small
                style="font-size: 12px"
              >
                mdi-phone
              </v-icon>
            </v-btn>
          </a>
        </template>
        <template v-slot:item.remain="{ item }">
          <a
            v-if="item.remain"
            @click="turnover(item)"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ (item.remain ? $numberFormat(item.remain.remain) : 0) }}
            </v-btn>
          </a>
        </template>
        <template v-slot:item.state="{ item }">
          <v-chip
            v-show="item.remain && parseFloat(item.remain.remain) < 0"
            small
            color="blue"
            outlined
          >
            {{ $t('creditor') }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain > 0"
            small
            color="red"
            outlined
          >
            {{ $t('debtor') }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain == null"
            small
            color="green"
            outlined
          >
            {{ $t('clearing') }}
          </v-chip>
        </template>
        <template v-slot:item.rank="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-if="item.rank"
                class="mx-1"
                color="amber"
                text-color="brown"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  left
                  size="15"
                >
                  mdi-language-ruby
                </v-icon>
                {{ item.rank }}
              </v-chip>
            </template>
            <span>{{ $t('point') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.tags="{ item }">
          <div
            class="pt-1"
            @click="edit(item)"
          >
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.uid="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                v-on="on"
                @click="openPointDialog(item)"
              >
                <v-icon
                  color="green"
                >
                  mdi-account-school-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('grade') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.event.grade"
                v-bind="attrs"
                icon
                v-on="on"
                @click="sendSmsStudentGrade(item)"
              >
                <v-icon
                  color="blue"
                >
                  mdi-message-reply-text-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('sendSmsGrade') }}</span>
          </v-tooltip>
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - 5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('amount') + ':' : '') }} {{ $numberFormat(totals.amount) }}  {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="pointDialog"
      width="400"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn
            icon
            class="close-hover"
            @click="pointDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('grade') }}
          </p>
        </v-col>
        <v-col
          v-if="student"
          class="mt-3"
        >
          <v-text-field
            v-model="student.event.grade"
            :label="$t('grade')"
            height="20"
            dense
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col
              cols="10"
              class="px-0"
            >
              <v-btn
                color="primary"
                small
                @click="gradeSubmit('deactive')"
              >
                {{ $t('submit') }}
              </v-btn>
              <v-btn
                color="green"
                style="margin-right: 8px !important;"
                small
                @click="gradeSubmit('active')"
              >
                {{ $t('submitAndSendSms') }}
              </v-btn>
            </v-col>
            <v-col
              cols="2"
              class="px-0"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left"
                small
                @click="pointDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col md="2">
            <v-checkbox
              v-model="lead"
              class="mt-0"
              :label="$t('lead')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col md="2">
            <v-checkbox
              v-model="status"
              class="mt-0"
              :label="$t('active')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="financialStatus"
              :label="$t('financial-status')"
              :items="financialStatusItems"
              height="32"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="attractionMethod"
              :title="$t('attractionMethod')"
              type="attractionMethod"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialogList"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialogList = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('tasks') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list
            ref="refTaskList"
            type="account"
            :ref-id="refId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="accountDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            color="grey darken-2"
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('new-account') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <account
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import TaskList from '../task/list'
  import Account from '../account/customer'
  import Upload from '../../components/general/upload/upload'
  import General from '../../../../Mixins/general'
  import Print from '../../components/general/Print/Index'
  // import pdfPrint from '../../components/general/Print/pdfPrintTable'
  export default {
    name: 'AcademyEventStudentList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Print,
      Task,
      // pdfPrint,
      TaskList,
      Upload,
      Account,
    },
    mixins: [General],
    props: ['input', 'type', 'data', 'integratorTypeProp', 'eventProp'],
    data: () => ({
      excelItems: [],
      selected: [],
      event: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      customerStatusItems: null,
      financialStatusItems: null,
      pointDialog: false,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      pageCount: 1,
      page: 1,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      headers: null,
      personnel: null,
      student: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        const totals = this.items.reduce((acc, d, index) => {
          acc.amount += parseFloat((d.remain ? d.remain.remain : 0))
          return acc
        }, {
          amount: 0,
        })
        app.renderTable = true
        return totals
      },
    },
    watch: {
      event (val) {
        if (val) {
          this.getItems()
        } else {
          this.items = []
        }
      },
      eventProp (val) {
        this.event = null
        this.items = []
        if (val) {
          this.event = val
        }
      },
      taskDialogList (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      taskDialog (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          app.page = app.options.page
          app.itemsPerPage = app.options.itemsPerPage
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      if (this.$route.params.financialStatus) {
        this.financialStatus = this.$route.params.financialStatus
      }
      this.customerStatusItems = [
        {
          value: 'lead',
          text: this.$t('lead'),
        },
        {
          value: 'on',
          text: this.$t('active'),
        },
      ]
      this.financialStatusItems = [
        {
          value: '>',
          text: this.$t('debtor'),
        },
        {
          value: '<',
          text: this.$t('creditor'),
        },
        {
          value: '=',
          text: this.$t('clearing'),
        },
      ]
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          table: 'users.id',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'users.id',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'firstname',
          table: 'users.name',
        },
        {
          text: this.$t('academyEventName'),
          sortable: false,
          value: 'event.event.name',
        },
        {
          text: this.$t('place'),
          sortable: false,
          value: 'event.event.place.name',
        },
        {
          text: this.$t('startTime'),
          sortable: false,
          value: 'event.event.start_time',
        },
        {
          text: this.$t('national-code'),
          sortable: true,
          value: 'national_code',
          table: 'users.national_code',
        },
        {
          text: this.$t('phone'),
          sortable: true,
          value: 'phone',
          table: 'users.phone',
        },
        {
          text: this.$t('mobile'),
          sortable: true,
          value: 'mobile',
          table: 'users.mobile',
        },
        {
          text: this.$t('remain'),
          sortable: false,
          value: 'remain',
        },
        {
          text: this.$t('financial-status'),
          sortable: false,
          value: 'state',
        },
        {
          text: this.$t('grade'),
          sortable: false,
          value: 'event.grade',
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
        },
        {
          text: this.$t('actions'),
          sortable: true,
          value: 'uid',
        },
      ]
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.eventProp) {
        this.event = this.eventProp
      }
      // this.getItems()
    },
    methods: {
      sendSmsStudentGrade (item) {
        var app = this
        app.loading = true
        var data = {
          sendGradeSms: 'active',
          student: item,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openPointDialog (item) {
        this.student = item
        this.pointDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        if (this.$refs.refTask) {
          this.$refs.refTask.clearForm()
        }
        this.taskItem = item
        this.taskDialog = true
      },
      openTaskDialogList (item) {
        if (this.$refs.refTaskList) {
          this.$refs.refTaskList.getItems()
        }
        this.refId = item.id
        this.taskDialogList = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'customerEdit', params: { id: item.id } })
      },
      studentAttendance (item) {
        this.$router.push({ name: 'academyEventStudentAttandance', params: { eventProp: this.event, studentProp: item.id } })
      },
      gradeSubmit (sms) {
        if (!this.event) {
          return false
        }
        var app = this
        app.pointDialog = false
        app.loading = true
        app.clearing = true
        app.showing = true
        var data = {
          setGrade: 'active',
          student: this.student,
          sms: sms,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            app.student = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      payment (item, type) {
        this.$router.push({ name: type, params: { accountProp: item } })
      },
      events (item) {
        this.$router.push({ name: 'academyEventList', params: { studentIdProp: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            getEventStudentsList: 'active',
            event: app.event,
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            page: (app.allRows ? app.excelPage : app.options.page),
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.options,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.last_page = res.last_page
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      print () {
        this.$htmlToPaper('print')
      },
      turnover (item) {
        this.$router.push({ name: 'turnover', params: { accountProp: { fin_id: item.fin_id, name: item.name } } })
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            name: String(d.name),
            event: (d.event ? String(d.event.event.name) : null),
            place: (d.event && d.event.event.place ? String(d.event.event.place.name) : null),
            startTime: (d.event ? String(d.event.event.start_time) : null),
            score: (d.event ? String(d.event.grade) : null),
            category: (d.category ? d.category.name : ''),
            phone: (d.phone ? String(d.phone) : ''),
            remain: (d.remain ? d.remain.remain : ''),
            mobile: (d.mobile ? (d.mobile) : ''),
            email: (d.email ? d.email : ''),
            address: (d.address ? d.address : ''),
            birth_date: (d.birth_date ? d.birth_date : ''),
            country: (d.country ? d.country.name : ''),
            state: (d.state ? d.state.name : ''),
            city: (d.city ? d.city.name : ''),
            content: (d.content ? d.content : ''),
          })
        })
      },
    },
  }
</script>

<style scoped>
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
